import { createSlice } from "@reduxjs/toolkit";
import { status_slices } from "../../../../../config/constants";


export const cashOutSlice = createSlice({
    name: 'cashOut',
    initialState: {
        status: status_slices.WAITING,// loaded | not_loaded
        isLoading: false,
        msg: '',
        dateStart: '',
        dateEnd: '',
        list_cashOut: [],
        cashOut_detail: [],
        orders_totals: [],
        sales_totals: [],
        advancedPayment_totals: [],
        orders_details: [],
        sales_details: [],
        advancedPayment_details: [],
        discounts_totals: [],
        discounts: [],
    },
    reducers: {
        processRequest: (state, action) => {
            state.isLoading = true;
            state.status = status_slices.PROCESSING;
        },
        notProcessRequest: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
        },
        setError: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.NOT_LOADED;
            state.msg = action.payload.msg;
            state.dateStart = '';
            state.dateEnd = '';
            state.orders_totals = [];
            state.sales_totals = [];
            state.advancedPayment_totals = [];
            state.orders_details = [];
            state.sales_details = [];
            state.advancedPayment_details = [];
            state.list_cashOut = [];
            state.discounts_totals = [];
            state.discounts = [];
        },
        setDataCashOutList: (state, action) => {
            state.isLoading = false;
            state.msg = action.payload.msg;
            state.list_cashOut = action.payload.list_cashOut;
        },
        setCashOutDetail: (state, action) => {
            state.isLoading = false;
            state.msg = action.payload.msg;
            state.cashOut_detail = action.payload.cashOut_detail;
        },
        setData: (state, action) => {
            state.isLoading = false;
            state.msg = action.payload.msg;
            state.dateStart = action.payload.dateStart;
            state.dateEnd = action.payload.dateEnd;
            state.status = status_slices.SUCCESS;
            state.orders_totals = action.payload.orders_totals;
            state.sales_totals = action.payload.sales_totals;
            state.advancedPayment_totals = action.payload.advancedPayment_totals;
            state.orders_details = action.payload.orders_details;
            state.sales_details = action.payload.sales_details;
            state.advancedPayment_details = action.payload.advancedPayment_details;
            state.discounts_totals = action.payload.discounts_totals;
            state.discounts = action.payload.discounts;
        },
        clearMemory: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
            state.msg = '';
            state.dateStart = '';
            state.dateEnd = '';
            state.orders_totals = [];
            state.sales_totals = [];
            state.advancedPayment_totals = [];
            state.orders_details = [];
            state.sales_details = [];
            state.advancedPayment_details = [];
            state.discounts = [];
            state.discounts_totals = [];
            // state.discounts = [];
        },
        clearMemoryCashOutDetail: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
            state.msg = '';
            state.cashOut_detail = [];
        }
    }
})


// Action creators are generated for each case reducer function
export const { notProcessRequest, processRequest, clearMemory, setData, setError, setDataCashOutList, setCashOutDetail, clearMemoryCashOutDetail } = cashOutSlice.actions;